/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Tooltip } from '@scuf/common';
import ITooltipProps from '@scuf/common/dist/components/Tooltip/ITooltipProps';
import React from 'react';

const EnergyOptimizationLabelTooltip = (props: ITooltipProps) => {
  const defaultProps = {
    position: 'bottom left',
    event: 'hover',
    size: 'mini'
  } as Partial<ITooltipProps>;
  const tooltipProps = {
    ...defaultProps,
    ...props
  } as ITooltipProps;
  return (
    <Tooltip
      {...tooltipProps}
      className={`energy-optimization-label-tooltip ${tooltipProps.className}`}
    />
  );
};

export default EnergyOptimizationLabelTooltip;
